import { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { USE_API } from '../config/env';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { getFaqsAction } from '../store/actions/faqActions';
import { Container } from '../components/layout/Primitives';

const STATIC_FAQS = [
  {
    q: 'How long does shipping take?',
    a: 'Standard shipping usually arrives within 3-7 business days. Express options are shown at checkout based on your region.',
  },
  {
    q: 'Can I return sale items?',
    a: 'Sale items can be returned unless clearly marked final sale on the product page.',
  },
  {
    q: 'How do I choose the right size?',
    a: 'Use the size guide on each product page. If you are between sizes, choose based on your preferred fit.',
  },
  {
    q: 'Do I need an account to checkout?',
    a: 'You can browse without an account, but account sign-in is required for review submissions and order management.',
  },
];

function normalizeFaqs(list) {
  if (!Array.isArray(list)) return [];
  return list
    .map((f) => ({ q: f?.question || f?.q || '', a: f?.answer || f?.a || '' }))
    .filter((f) => f.q && f.a);
}

export default function FAQ() {
  const dispatch = useAppDispatch();
  const { list, loading, error } = useAppSelector((s) => s.faq);

  useEffect(() => {
    if (!USE_API) return;
    dispatch(getFaqsAction());
  }, [dispatch]);

  const apiFaqs = useMemo(() => normalizeFaqs(list), [list]);
  const faqs = USE_API && apiFaqs.length > 0 ? apiFaqs : STATIC_FAQS;

  return (
    <div className="animate-fade-in">
      <section style={{ background: 'hsl(36, 24%, 95%)', borderBottom: '1px solid hsl(35,18%,84%)' }}>
        <Container style={{ padding: '3.5rem 1.5rem 3rem' }}>
          <h1 className="font-display" style={{ margin: 0, fontSize: 'clamp(2rem,4vw,3.25rem)' }}>FAQs</h1>
          <p style={{ margin: '0.9rem 0 0', opacity: 0.75 }}>Common questions about ordering, shipping, and returns.</p>
          {USE_API && loading ? <p style={{ margin: '0.9rem 0 0', opacity: 0.7 }}>Loading…</p> : null}
          {USE_API && error ? <p style={{ margin: '0.9rem 0 0', color: '#8B3A2A' }}>{error}</p> : null}
        </Container>
      </section>
      <Container style={{ padding: '2.5rem 1.5rem 4rem', display: 'grid', gap: '1rem', maxWidth: '54rem' }}>
        {faqs.map((item) => (
          <article key={item.q} style={{ border: '1px solid hsl(35,18%,84%)', padding: '1rem 1.1rem' }}>
            <h2 style={{ margin: 0, fontSize: '1.02rem' }}>{item.q}</h2>
            <p style={{ margin: '0.55rem 0 0', opacity: 0.75, lineHeight: 1.65 }}>{item.a}</p>
          </article>
        ))}
        <p style={{ margin: '0.5rem 0 0', opacity: 0.7 }}>
          Still need help? <Link to="/customer-service" style={{ textDecoration: 'underline' }}>Customer service</Link>
        </p>
      </Container>
    </div>
  );
}
